import styled from 'styled-components'
// icons
import AddIconOrigin from '@mui/icons-material/Add'
import FilterIconOrigin from '@mui/icons-material/FilterList'
import ScheduleReviewIconOrigin from 'src/icons/schedule-review.svg'
// utils
import { ellipsis, size } from 'polished'

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
  gap: 8px;
`

export const ViewLabel = styled.span`
  align-self: center;
  font-size: 20px;
  margin-right: auto;

  ${ellipsis('100%')};
`

export const FilterIcon = styled(FilterIconOrigin)`
  && {
    ${size('24px')};
  }
`

export const AddIcon = styled(AddIconOrigin)`
  && {
    ${size('24px')};
  }
`

export const ScheduleReviewIcon = styled(ScheduleReviewIconOrigin)`
  && {
    ${size('20px')};
  }
`
